import React from 'react';
import '../styles/whyus.css';

function WhyUs() {
    return (
        <div className="whyus-container">
            <div className="whyus-title">
                <h2>Why Us?</h2>
            </div>
            <div className="whyus-content">
                <p>
                    Dreaming of turning your Pinterest mood board into reality or adding smart home automations to simplify life?
                    Need extra storage for your partner and a fun play space for the kids?
                    Stop wondering how to create a home that works for everyone– At Spacesio Studios we’ve got creative solutions to match your lifestyle!
                    Book a call with us to explore innovative ideas on how we can elevate your home.
                </p>
                <p>
                    Looking to design a professional office space that aligns with your brand's vibe and resonates with your clients and customers? Or is a home office all that you want? - You're in the right place!
                    Whatever you have in mind- Bespoke design or a minimalist approach? Traditional aesthetics, or contemporary interior?- we have designed them all.
                </p>
                <p>
                    What sets us apart is our unwavering commitment to quality!!
                    At Spacesio Studio, we never compromise. Every element that goes into your space is of the highest quality. Why look elsewhere when you have premium interior decor tailored perfectly to your budget?
                </p>
            </div>
        </div>
    );
};

export default WhyUs;